import React from 'react';
import {Route, Switch} from 'react-router-dom';
import LandingPage from './landingpage';
import Contact from './contact';
const Main = () => (
    <Switch>
        <Route exact path = '/' component={LandingPage}/>
        <Route path = '/aboutme' component={LandingPage}/>
        <Route path = '/contact' component={Contact}/>
    </Switch>
)
export default Main;